import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    item: {
        display: "flex",
        gap: ".5rem",
        height: "2.5rem",
        padding: ".75rem",
        color: theme.colors.gray[7],
    },
}))
